import React, { useState, useEffect } from 'react';
import _ from 'lodash'
import { FormattedMessage } from 'react-intl';

import 'draft-js/dist/Draft.css';

import Box from '@mui/material/Box';
import Select from '@mui/material/Select';
import MenuItem from '@mui/material/MenuItem';

import { KeyboardArrowDownOutlinedIcon } from '../../../constants/images';

import { CustomFormLabel } from '../../customComponent';

import useGlobalStatus from '../../../hook/useGlobalStatus';
import useColorSystem from '../../../hook/useColorSystem';

import * as urlConstants from '../../../constants/url';


const CONVERSIONS_TYPE = [
  {
    id: 'common.conversion.conversion',
    value: 'conversions',
  },
  {
    id: 'common.conversion.allConversion',
    value: 'allConversions',
  },
  {
    id: 'common.conversion.noConversion',
    value: 'noConversions',
  },
]

const GoogleConversionData = (props) => {
  const {
    conversionsType,
    setConversionsType,
    setCurrentSheetName,
    setSelectedExcelIndex,
    setSelectedConversionsFields,
    tickAllConversionsData,
    tickConversionsData,
    conversionsData,
  } = props;

  const { currentActiveData, entryPath } = useGlobalStatus();
  const { colorMedia, mainColor, lightColor, darkColor, w01Color } = useColorSystem();
  const [changeConversions, setChangeConversions] = useState(false);

  const handleConversionFields = (e) => {
    setConversionsType(e.target.value);
    setChangeConversions(true);
  }

  useEffect(() => {
    if (entryPath.includes('edit')) {
      setConversionsType(currentActiveData.conversionsType);
    }
  }, [entryPath])

  useEffect(() => {
    if (entryPath === urlConstants.PAGE_GOOGLE_CREATE_DATA) {
      if (conversionsType === "allConversions") {
        tickAllConversionsData[3].sheet = ['menu'];
        setSelectedConversionsFields(tickAllConversionsData);
      } else if (conversionsType === "conversions") {
        setSelectedConversionsFields(tickConversionsData);
      } else {
        conversionsData[3].sheet = ['menu'];
        setSelectedConversionsFields(conversionsData);
      }
      setSelectedExcelIndex();
      setCurrentSheetName("");
    }

    if (changeConversions === false) return;

    if (entryPath === urlConstants.PAGE_GOOGLE_EDIT_DATA) {
      if (conversionsType === "allConversions") {
        setSelectedConversionsFields(tickAllConversionsData);
      } else if (conversionsType === "conversions") {
        setSelectedConversionsFields(tickConversionsData);
      } else {
        setSelectedConversionsFields(conversionsData);
      }
      setSelectedExcelIndex();
      setCurrentSheetName("");
    }

  }, [conversionsType])

  return (
    <Box mb={2}>
      <CustomFormLabel>
        <FormattedMessage id="common.conversion.Type" /><span>*</span>
      </CustomFormLabel>
      <Select
        value={conversionsType}
        IconComponent={KeyboardArrowDownOutlinedIcon}
        onChange={(e) => handleConversionFields(e)}
        sx={{
          width: '22%',
          "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
            borderColor: mainColor
          }
        }}
      >
        {CONVERSIONS_TYPE.map((el) => (
          <MenuItem
            key={el.id}
            value={el.value}
            sx={{ "&.Mui-selected": { backgroundColor: w01Color } }}
          >
            <FormattedMessage id={el.id} />
          </MenuItem>
        ))}
      </Select>
    </Box>
  )
}

export default GoogleConversionData;